import { reporting } from './financeReporting';
export const suite = (path, options) => reporting('/suite' + path, options);
export function millimes(value) {
  const s = String(value).trim().replace(',', '.');
  if (!/^-?\d+(\.\d{1,3})?$/.test(s)) throw new Error('Montant TND : trois décimales au maximum.');
  const neg = s.startsWith('-'); const [whole, part = ''] = s.replace('-', '').split('.');
  const n = Number(whole) * 1000 + Number(part.padEnd(3, '0'));
  if (!Number.isSafeInteger(n) || n > 10 ** 15) throw new Error('Montant trop élevé.');
  return neg ? -n : n;
}
export const saisieMontant = (n = 0) => (n < 0 ? '-' : '') + Math.trunc(Math.abs(n) / 1000) + '.' + String(Math.abs(n) % 1000).padStart(3, '0');
export function dateExercice(exercice) {
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Tunis', year:'numeric', month:'2-digit', day:'2-digit' }).format(new Date());
  return today.startsWith(String(exercice)) ? today : exercice + '-12-31';
}
export function fichier(data, name, type='application/json') {
  const url=URL.createObjectURL(new Blob([typeof data === 'string' ? data : JSON.stringify(data,null,2)],{type}));
  const a=document.createElement('a'); a.href=url; a.download=name; a.click(); setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export async function archiveFinance(id) {
  const root = process.env.REACT_APP_BACKEND_URL + '/api/reporting-finance/suite';
  const r = await fetch(root+'/exports/'+encodeURIComponent(id)+'/archive', {credentials:'include'});
  if (!r.ok) { const d=await r.json(); throw new Error(d.detail || 'Téléchargement impossible.'); }
  const url=URL.createObjectURL(await r.blob()); const a=document.createElement('a');a.href=url;a.download='finance-'+id.slice(0,12)+'.zip';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
